import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap, tap } from 'rxjs';
import { Role } from 'src/app/model/roles';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class RoleDataService extends DefaultDataService<Role> {
    r: Role[] = [];
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
        super('Region', http, httpUrlGenerator);
    }

    override getAll(): Observable<Role[]> {
        const url = this.urlProvider.getUrl(EndPoints.role, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    this.r = <Role[]>res.body['roles'];
                    return of(this.r);
                })
            );
    }
}
